import React from 'react';
import { Link } from 'react-router-dom';
import services from '../data/services';

export default function Services() {
  return (
    <>
      <section className="page-hero">
        <div className="container page-hero-inner">
          <span className="eyebrow">Services</span>
          <h1>Complete business IT support, presented service by service.</h1>
          <p>
            Browse the core solutions we provide across infrastructure, storage, repairs, recovery,
            security, and long-term maintenance.
          </p>
        </div>
      </section>

      <section className="container section">
        <div className="service-grid service-grid-full">
          {services.map((service) => (
            <article key={service.id} className="service-card service-card-detailed">
              <img src={service.image} alt={service.title} className="service-thumb" />
              <div className="service-card-body">
                <span className="service-tag">{service.category}</span>
                <h2>{service.title}</h2>
                <p>{service.description}</p>
                <ul className="bullet-list">
                  {service.highlights.map((highlight) => (
                    <li key={highlight}>{highlight}</li>
                  ))}
                </ul>
                <div className="service-card-footer">
                  <span>{service.idealFor}</span>
                  <Link to={`/services/${service.id}`} className="btn btn-outline-accent">
                    More Details
                  </Link>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>
    </>
  );
}
